<template>
  <div class="innerBox">

    <h2 class="mb-4">Master Sparepart</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tipe Sparepart</label>
            <Multiselect
				:options="sparepartType.map(x => x.variable)"
				:custom-label="opt => sparepartType.find(x => x.variable == opt).name"
				v-model="vue_universal_table.filter.sparepartType"
				placeholder="Pilih Tipe Sparepart"
			/>
			
          </div>
		  <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Merek Mobil</label>
			<Multiselect
				id="car_brand"
				class="mt-1"
				:options="options.brand.map(x => x.name)"
				
				v-model="vue_universal_table.filter.brand"
				placeholder="Isi Merek Mobil"
			/>
		  </div>
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:43px; margin-bottom:1.5%" @click="search()">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      :api_url="vue_universal_table.url"
	  :pagination="true"
	  :indexing="true"
	  :fields="vue_universal_table.fields"
	  :process_data="vue_universal_table.process_data"
	  :update="vue_universal_table.update"
	  :buttons="vue_universal_table.buttons"
	  :disable_sort="true"
	  @onSejarahSparepart="showSparepartHistoryTransaction"
	  @onTambahSparepart="addSparepart = true"
	  :special_buttons="vue_universal_table.special_buttons"
    ></vue-universal-table>

	<sparepartHistoryModal 
		v-if="dataHistory"

		:data="dataHistory"
		@closeModal="dataHistory = null"

	/>

	<newSparepart 
		v-if="addSparepart"
		@closeModal="addSparepart = false"
		@updateTable="vue_universal_table.update++"
	/>


  </div>
</template>

<script>
	import moment from 'moment'
	import Multiselect from 'vue-multiselect'
	import sparepartHistoryModal from './children/sparepartHistoyModal'
	import newSparepart from './children/newSparepart'

	export default {
		data () {
			const start = moment().startOf('year').format('YYYY-MM-DD');
			let end  = new moment().format('YYYY-MM-DD')
			let baseUrl = '/api/v1/inventory'

			let url = baseUrl + '?k=Brand.name&c=like&v=%&ignoreSize=true'

			return {
				baseUrl :  baseUrl,
				options : this.$store.getters.getFilterOptions,
				data : null,
				startingUrl : url,
				dataHistory : null,
				addSparepart : false,
				
				
				sparepartType : [{
					variable : 'J',
					name : 'Jasa'
				},{
					variable : 'P',
					name : 'Part'
				},{
					variable : 'B',
					name : 'Bahan'
				}, {
					variable : 'O',
					name : 'Lainnya'
				}],
				meta : null,
				data: null,
				mobile : this.isMobile(),
				selected : {
				date : `${start} to ${end}`,
				},
				rangeConfig: {
				mode: 'range',
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
				},
				showNewUserModal : false,
				apiLoading: true,
				vue_universal_table : {
					update: 0,
					url : url,
					process_data : `
						data = data.results

						for (var i = 0 ; i < data.length ; i++) {
							data[i].part_number = data[i].part_number ? data[i].part_number : ' - ';
						}
					`,
					special_buttons : ['TambahSparepart'],
					buttons : [
						{
							title : 'sejarahSparepart',
							variable : 'sparepart_id',
							class : 'btn-outline-info fas fa-history'
						}
					],
					filter: {
						sparepartType : null,
						brand : null,
						partNumber : ''
					},
					fields : [
						{
							title : 'Tipe Sparepart',
							variable : 'sparepart_type'
						},
						{
							title : 'Nama Sparepart',
							variable : 'sparepart_name'
						},
						{
							title : 'Merek Mobil',
							variable : 'brand_name'
						}, 
						{
							title : 'Jumlah Stok',
							variable : 'stocks'
						}
					]
				}
			}
		},
		components : {
			Multiselect,
			sparepartHistoryModal,
			newSparepart
		},
		mounted () {
			
		},
		methods : {
			createNewWorkOrder () {
				this.$router.push({name : 'WorkOrderFormNew'})
			},
			viewDetailWO (x) {
				this.$router.push({name : 'WorkOrderDetail', query: {wo:x.replace(/"/g, "")}})
			},
			async search () {
				let filterString = await this.loadFilter()

				if(filterString != '?')
					this.vue_universal_table.url = this.baseUrl + filterString
				else 
					this.vue_universal_table.url = this.startingUrl

				this.vue_universal_table.update++;
			},
			async loadFilter () {
				let filter = this.vue_universal_table.filter
				let stringUrl = '?ignoreSize=true&'

				let keys = Object.keys(filter)

				for(var i = 0 ; i < keys.length ; i++) {
					if(filter[keys[i]] == null || filter[keys[i]] == '')
						continue

					let obj = await this.dictionaryVariable(keys[i])
					obj.v = filter[keys[i]]
					let type = obj.c
					
					let keysObject = Object.keys(obj)

					for(var j = 0 ; j < keysObject.length ; j++) {
						if(type == 'like' && keysObject[j] == 'v')
							stringUrl += `${keysObject[j]}=%${obj[keysObject[j]]}%&`
						else {
							stringUrl += `${keysObject[j]}=${obj[keysObject[j]]}&`
						}
					}

				}

				return stringUrl
			},
			dictionaryVariable (varName) {
				if(varName == 'sparepartType') {
					return {
						k : 'Type.name',
						c : '='
					}
				}
				else if (varName == 'brand')
					return {
						k : 'Brand.name',
						c : '='
					}
				else if (varName == 'partNumber')
					return {
						k : 'Spareparts.part_number',
						c : 'like'
					}
			},
			showSparepartHistoryTransaction (id) {

				this.dataHistory = null;

				this.$http.get('/api/v1/transactions/inventory/' + id)
				.then((resp) => {
					this.dataHistory = resp.data.data

					
				})
				.catch((err) => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
  
</style>